/** Activity module command types (runtime cutover). */
export const ACTIVITY_COMMAND_TYPES = {
  SYNC_LIVE_STATE: "SyncLiveState",
  SET_ORCHESTRATION_PAUSE: "SetOrchestrationPause",
};
